import { render, staticRenderFns } from "./CleaSkill.vue?vue&type=template&id=8d7a937e&"
import script from "./CleaSkill.vue?vue&type=script&lang=js&"
export * from "./CleaSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports